import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function NotificationSkeleton({ count = 4 }) {
    return (
        <SkeletonTheme baseColor="#1E2631" highlightColor="#262E3E" borderRadius="4px">
            <div style={{ display: "flex", flexDirection: "column", gap: "12px", width: "100%", padding: "0px 20px" }}>
                {[...Array(count)].map((_, index) => (
                    <div
                        key={index}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            width: "100%",
                            justifyContent: "space-between"
                        }}>
                        <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
                            <div className="Box">
                                <Skeleton
                                    circle
                                    style={{
                                        backgroundColor: "#1E2631",
                                        height: "16px",
                                        width: "16px"
                                    }}
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "4px", width: "170px" }}>
                                <Skeleton
                                    style={{
                                        backgroundColor: "#1E2631",
                                        width: "137px",
                                        height: "12px"
                                    }}
                                    borderRadius="4px"
                                />
                                <Skeleton
                                    style={{
                                        backgroundColor: "#1E2631",
                                        width: "104px",
                                        height: "12px"
                                    }}
                                    borderRadius="4px"
                                />
                            </div>
                        </div>
                        <div className="">
                            <Skeleton
                                style={{
                                    backgroundColor: "#1E2631",
                                    width: "34px",
                                    height: "12px"
                                }}
                                borderRadius="4px"
                            />
                        </div>
                    </div>
                ))}
            </div>
        </SkeletonTheme>
    );
}
